<template>
  <div>
    <div class="banner">
      <img src="@/assets/images/newlocations/lacoste/banner.jpg" class="w100" />
    </div>

    <div class="cust-content">
      <div class="head-info" v-if="$i18n.locale === 'en'">
        <div class="head-title">
          SCAD Lacoste — the art of living and creating in Provence
        </div>
        <div class="head-desc">
          Nestled in the hills of southern France, SCAD Lacoste is a living
          studio — where centuries-old architecture meets cutting-edge
          creativity. Artists, designers, and scholars find inspiration in the
          same golden light that drew Monet, Van Gogh, and Picasso.
        </div>
        <div class="head-tags">
          <span class="head-tag">20+ years of global learning</span>
          <span class="head-tag">Courses for all majors</span>
          <span class="head-tag">Alumni in 100+ countries</span>
        </div>
      </div>

      <div class="head-info" v-if="$i18n.locale === 'zh'">
        <div class="head-title">SCAD 拉科斯特 — 在普罗旺斯，生活即创作</div>
        <div class="head-desc">
          坐落于法国南部山丘的 SCAD
          拉科斯特校区，是一个融合历史与现代的艺术创作空间。艺术家与设计师在这里汲取灵感，延续着莫奈、梵高、毕加索的艺术足迹。
        </div>
        <div class="head-tags">
          <span class="head-tag">20+ 年全球创意教育</span>
          <span class="head-tag">覆盖所有专业方向</span>
          <span class="head-tag">全球校友遍布 100+ 个国家</span>
        </div>
      </div>
      <div class="locationMenu">
        <div class="grid-content">
          <div class="locationMenuList">
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Atlanta' ? 'active' : ''"
              @click="locationMenuItemClick('Atlanta')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_01.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">A</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">Atlanta</div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">
                  亚特兰大
                </div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Lacoste' ? 'active' : ''"
              @click="locationMenuItemClick('Lacoste')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_02.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">L</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">Lacoste</div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">
                  拉科斯特
                </div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Savannah' ? 'active' : ''"
              @click="locationMenuItemClick('Savannah')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_03.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">S</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">
                  Savannah
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">萨凡纳</div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'SCADnow' ? 'active' : ''"
              @click="locationMenuItemClick('SCADnow')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_04.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">e</div>
                </div>
                <div class="nav-name">SCADnow</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="video-box">
      <video
        src="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20251103/HZ_2025-26_SCN_SCAD_Lacoste.01_final.mp4"
        controls
        poster="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20251103/HZ_2025-26_SCN_SCAD_Lacoste.01_final.mp4?x-oss-process=video/snapshot,t_5000,m_fast"
      ></video>
    </div>

    <div class="cust-content">
      <div v-if="$i18n.locale === 'en'">
        <div class="grid-content content">
          <el-row class="why-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="12" class="vertical-center">
              <div class="content-title">Why Lacoste</div>
              <div class="text flex-align-items-center">
                <div>
                  A study-abroad experience unlike any other. In Lacoste,
                  students earn credits toward their SCAD degree while immersing
                  themselves in art, culture, and the beauty of Provence.
                  Courses rotate each quarter — from fashion to
                  <a
                    href="https://uat.scadedu.cn/Programs/36/B.F.A.%20in%20film%20and%20television.html"
                    target="_blank"
                    >film</a
                  >, animation to art history — offering new perspectives and
                  lifelong inspiration.
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://www.scadedu.cn/Academic/"
                  >Explore facilities and programs</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/lacoste/04why/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <div class="building-box">
            <div
              class="
                building-banner-swiper-container
                swiper-container
                location-banner
              "
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? buildingCnBanners
                    : buildingEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row
            class="margin-top career-box"
            style="margin-top: 60px"
            :gutter="30"
          >
            <el-col :xs="24" :md="11">
              <div class="content-title">Career pathways</div>
              <div class="text" style="margin-top: 30px">
                From classroom to countryside, students expand their worldview
                through excursions across Provence — from Aix-en-Provence to
                Marseille and Nîmes. Through
                <a
                  href="https://www.scad.edu/about/industry-partnerships/scadpro"
                  target="_blank"
                  >SCADpro</a
                >
                Europe projects, they collaborate with global brands and
                creative studios.
              </div>
              <div class="tags">
                <a
                  href="https://www.scadedu.cn/Programs/14/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%8A%A8%E7%94%BB.html"
                  class="tag"
                  target="_blank"
                  >Animation</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/45/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%B9%B3%E9%9D%A2%E8%AE%BE%E8%AE%A1%E4%B8%8E%E8%A7%86%E8%A7%89%E4%BC%A0%E8%BE%BE.html"
                  class="tag"
                  target="_blank"
                  >Illustration</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/56/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E4%BA%92%E5%8A%A8%E8%AE%BE%E8%AE%A1%E4%B8%8E%E6%B8%B8%E6%88%8F%E5%BC%80%E5%8F%91.html"
                  class="tag"
                  target="_blank"
                  >Interative design and game development</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/31/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E6%97%B6%E8%A3%85.html"
                  class="tag"
                  target="_blank"
                  >Fashion</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/101/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E8%A7%86%E8%A7%89%E7%89%B9%E6%95%88.html"
                  class="tag"
                  target="_blank"
                  >Visual effects</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="13">
              <div
                class="
                  career-banner-swiper-container
                  swiper-container
                  location-banner
                "
              >
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(banner, index) in careerCnBanners"
                    :key="index"
                  >
                    <div class="slide-inner">
                      <img :src="banner.src" alt="" />
                    </div>
                  </div>
                </div>

                <div class="swiper-pagination"></div>
                <img
                  class="button-prev"
                  src="@/assets/images/newlocations/img_01.png"
                  style="
                    position: absolute;
                    top: 50%;
                    left: 30px;
                    z-index: 999999;
                  "
                />

                <img
                  class="button-next"
                  src="@/assets/images/newlocations/img_02.png"
                  style="
                    position: absolute;
                    top: 50%;
                    right: 30px;
                    z-index: 999999;
                  "
                />
              </div>
            </el-col>
          </el-row>

          <el-row class="climate-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/lacoste/07climate/01.jpg"
                class="w100"
              />
            </el-col>

            <el-col :xs="24" :md="12" class="climate-content">
              <div class="content-title">Climate and transporation access</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>Climate</b>: Mediterranean — mild winters, sunny summers,
                    and crisp mountain air year-round.
                  </li>

                  <li>
                    <b>Global access</b>: Marseille Provence Airport (MRS)
                    connects Lacoste to major European cities.
                  </li>
                  <li>
                    <b>Regional Travel</b>: Easy access to Paris, Geneva, and
                    other cultural destinations across Europe.
                  </li>
                </ul>

                <div class="tips2">
                  <b>Note</b>: Can’t visit in person? Schedule a 10-minute
                  virtual tour or 1:1 meeting with SCAD Admission advisor.
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >Chat with admission</a
                >
              </div>
            </el-col>
          </el-row>

          <div class="life_community-box">
            <div class="content-title">Community and culture</div>
            <div class="text">
              Students live and learn surrounded by vineyards and lavender
              fields. Visiting artists — from Jean Paul Gaultier to
              <i>Vogue’s</i>
              Chioma Nnadi — share insights through talks and workshops. Alumni
              return for artist residencies, continuing the creative exchange.
            </div>

            <div
              class="
                lifeCommunity-banner-swiper-container
                swiper-container
                location-banner
              "
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in lifeCommunityCnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row class="recognition-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="10" class="vertical-center">
              <div class="content-title">Recognition</div>
              <div class="text" style="margin-top: 40px">
                Featured in:
                <ul style="margin-top: 5px">
                  <li>Condé Naste Traveler</li>

                  <li>Le Monde</li>
                  <li>Traveler + Leisure</li>
                  <li>The Guardian</li>
                </ul>
              </div>
            </el-col>

            <el-col :xs="24" :md="14">
              <img
                class="w100"
                src="@/assets/images/newlocations/lacoste/09recognition/01.jpg"
              />
            </el-col>
          </el-row>

          <el-row class="support-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="24" class="vertical-center">
              <div class="content-title">Plan your Lacoste experience</div>
              <div class="text">
                <div class="support-title">
                  Can I earn credits toward my SCAD degree?
                </div>
                <div class="support-text">
                  Yes. SCAD Lacoste courses count toward your SCAD major or
                  electives.
                </div>
                <div class="line"></div>

                <div class="support-title">
                  Do courses change every quarter at SCAD Lacoste?
                </div>
                <div class="support-text">
                  Yes. Parents and guardians are welcome to join our virtual
                  info sessions or book a 1:1 Chinese-language consultation with
                  SCAD admission advisers. Sessions include introductions,
                  career outcomes, and application guidance.
                </div>
                <div class="line"></div>
                <div class="support-title">
                  Can parents join an info session?
                </div>
                <div class="support-text">
                  Yes, we offer bilingual virtual sessions and Q&A.
                </div>
                <div class="line"></div>
              </div>
            </el-col>
          </el-row>

          <el-row class="scad-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="16">
              <div class="content-title">Start your SCAD journey</div>
              <div class="text">
                Click the 'Chat with Admission' to request program information
                or book a 1:1 consultation with a SCAD admission adviser. Our
                team responds in 2 business days with your Chinese info pack
                (program list + timeline).
              </div>
            </el-col>

            <el-col :xs="24" :md="8" class="vertical-center2">
              <div class="text">
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >Chat with admission</a
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div v-if="$i18n.locale === 'zh'">
        <div class="grid-content content">
          <el-row class="why-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="12" class="vertical-center">
              <div class="content-title">为什么选择拉科斯特</div>
              <div
                class="text flex-align-items-center"
                style="margin-top: 40px"
              >
                <div>
                  在 SCAD
                  拉科斯特，学生在感受普罗旺斯独特人文与自然风光的同时，修读
                  SCAD
                  学分课程。从时尚到电影、从动画到艺术史，每个季度的课程轮换都为创作注入全新的视野与创作灵感。
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://www.scadedu.cn/Academic/"
                  >探索校园设施与学位课程</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/lacoste/04why/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <div class="building-box">
            <div
              class="
                building-banner-swiper-container
                swiper-container
                location-banner
              "
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? buildingCnBanners
                    : buildingEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row
            class="margin-top career-box"
            style="margin-top: 60px"
            :gutter="30"
          >
            <el-col :xs="24" :md="11">
              <div class="content-title">职业方向</div>
              <div class="text" style="margin-top: 30px">
                课堂之外，学生通过探索艾克斯、马赛、尼姆等普罗旺斯城市，拓展世界观。通过
                <a
                  href="https://www.scad.edu/about/industry-partnerships/scadpro"
                  target="_blank"
                  >SCADpro</a
                >
                欧洲项目，与国际品牌及创意工作室合作，获得真实项目经验。
              </div>
              <div class="tags">
                <a
                  href="https://www.scadedu.cn/Programs/14/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%8A%A8%E7%94%BB.html"
                  class="tag"
                  target="_blank"
                  >动画</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/45/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%B9%B3%E9%9D%A2%E8%AE%BE%E8%AE%A1%E4%B8%8E%E8%A7%86%E8%A7%89%E4%BC%A0%E8%BE%BE.html"
                  class="tag"
                  target="_blank"
                  >插画</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/56/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E4%BA%92%E5%8A%A8%E8%AE%BE%E8%AE%A1%E4%B8%8E%E6%B8%B8%E6%88%8F%E5%BC%80%E5%8F%91.html"
                  class="tag"
                  target="_blank"
                  >交互设计与游戏开发</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/31/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E6%97%B6%E8%A3%85.html"
                  class="tag"
                  target="_blank"
                  >服装设计</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/101/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E8%A7%86%E8%A7%89%E7%89%B9%E6%95%88.html"
                  class="tag"
                  target="_blank"
                  >视觉特效</a
                >
              </div>
            </el-col>

            <!--            <el-col :xs="24" :md="13">-->
            <!--              <div-->
            <!--                class="-->
            <!--                  career-banner-swiper-container-->
            <!--                  swiper-container-->
            <!--                  location-banner-->
            <!--                "-->
            <!--              >-->
            <!--                <div class="swiper-wrapper">-->
            <!--                  <div-->
            <!--                    class="swiper-slide"-->
            <!--                    v-for="(banner, index) in careerCnBanners"-->
            <!--                    :key="index"-->
            <!--                  >-->
            <!--                    <div class="slide-inner">-->
            <!--                      <img :src="banner.src" alt="" />-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->

            <!--                <div class="swiper-pagination"></div>-->
            <!--                <img-->
            <!--                  class="button-prev"-->
            <!--                  src="@/assets/images/newlocations/img_01.png"-->
            <!--                  style="-->
            <!--                    position: absolute;-->
            <!--                    top: 50%;-->
            <!--                    left: 30px;-->
            <!--                    z-index: 999999;-->
            <!--                  "-->
            <!--                />-->

            <!--                <img-->
            <!--                  class="button-next"-->
            <!--                  src="@/assets/images/newlocations/img_02.png"-->
            <!--                  style="-->
            <!--                    position: absolute;-->
            <!--                    top: 50%;-->
            <!--                    right: 30px;-->
            <!--                    z-index: 999999;-->
            <!--                  "-->
            <!--                />-->
            <!--              </div>-->
            <!--            </el-col>-->

            <el-col :xs="24" :md="13">
              <img
                src="@/assets/images/newlocations/lacoste/06career/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <el-row class="climate-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/lacoste/07climate/01.jpg"
                class="w100"
              />
            </el-col>

            <el-col :xs="24" :md="12" class="climate-content">
              <div class="content-title">气候与交通</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>季节气候</b
                    >：地中海气候——冬季温和、夏季阳光充足，全年空气清新宜人。
                  </li>

                  <li>
                    <b>全球航点</b
                    >：马赛普罗旺斯机场（MRS）连接欧洲主要城市，往返便捷。
                  </li>
                  <li>
                    <b>区域通达</b>：
                    可轻松前往巴黎、日内瓦及欧洲其他文化目的地。
                  </li>
                </ul>

                <div class="tips2">
                  <b>温馨提示</b>： 暂时不能来访校园？您可以预约 10
                  分钟线上参观，或与 SCAD 招生官在线面对面交流。
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >预约专属 SCAD 招生官咨询</a
                >
              </div>
            </el-col>
          </el-row>

          <div class="life_community-box">
            <div class="content-title">生活与文化氛围</div>
            <div class="text">
              被葡萄园与薰衣草田包围的课堂，是拉科斯特最独特的风景。 <br />
              从让·保罗·高缇耶到 <i>Vogue</i> 的 Chioma
              Nnadi，艺术家们在讲座与工作坊中带来前沿的灵感与故事。 <br />
              许多校友也重返此地，以驻留艺术家的身份继续这场创意对话。
            </div>

            <div
              class="
                lifeCommunity-banner-swiper-container
                swiper-container
                location-banner
              "
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in lifeCommunityCnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row class="recognition-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="10" class="vertical-center">
              <div class="content-title">城市与院校荣誉</div>
              <div class="text" style="margin-top: 40px">
                媒体推荐：
                <ul style="margin-top: 5px">
                  <li>《悦游（Condé Nast Traveler）》</li>

                  <li>《Le Monde》</li>
                  <li>《漫旅 Travel + Leisure》</li>
                  <li>《卫报 The Guardian》</li>
                </ul>
              </div>
            </el-col>

            <el-col :xs="24" :md="14">
              <img
                class="w100"
                src="@/assets/images/newlocations/lacoste/09recognition/01.jpg"
              />
            </el-col>
          </el-row>

          <el-row class="support-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="24" class="vertical-center">
              <div class="content-title">规划你的拉科斯特学习体验</div>
              <div class="text">
                <div class="support-title">是否可获得 SCAD 学分？</div>
                <div class="support-text">
                  可以。拉科斯特校区的课程同样计入 SCAD 专业学分或选修学分。
                </div>
                <div class="line"></div>

                <div class="support-title">课程每季度都会变动吗？</div>
                <div class="support-text">
                  学术课程按季度循环开设，涵盖美妆与香水商业、服装设计、室内设计、动态媒体设计和动画等专业方向。
                </div>
                <div class="line"></div>
                <div class="support-title">家长可以参加线上资讯会吗？</div>
                <div class="support-text">
                  可以。家长可参与线上 SCAD
                  中文资讯会，或预约一对一招生顾问咨询，了解课程设置、就业成果与申请流程。
                </div>
                <div class="line"></div>
              </div>
            </el-col>
          </el-row>

          <el-row class="scad-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="16">
              <div class="content-title">开启你的 SCAD 之旅</div>
              <div class="text">
                填写表单即可获取课程资料，或预约与 SCAD 招生官一对一交流。<br />
                招生团队将在 2
                个工作日内回复，并发送中文资料包（含学位课程清单与申请时间线）。
              </div>
            </el-col>

            <el-col :xs="24" :md="8" class="vertical-center">
              <div class="text">
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >预约专属 SCAD 招生官咨询</a
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";

export default {
  data: function () {
    return {
      selectedMenu: "atlanta",
      buildingCnBanners: [
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_06.jpg"),
          url: "",
        },
      ],
      buildingEnBanners: [
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/05building/cn/swiper_06.jpg"),
          url: "",
        },
      ],

      careerCnBanners: [
        {
          src: require("@/assets/images/newlocations/lacoste/06career/01.jpg"),
          url: "",
        },
      ],
      lifeCommunityCnBanners: [
        {
          src: require("@/assets/images/newlocations/lacoste/08life_community/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/08life_community/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/08life_community/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/08life_community/04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/08life_community/05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/08life_community/06.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/lacoste/08life_community/07.jpg"),
          url: "",
        },
      ],
    };
  },
  mounted() {
    // this.selectedMenu = this.$route.params["name"];
    // var query = this.$route.query;
    // if (query.l) {
    //   this.selectedMenu = query.l;
    // }

    this.selectedMenu = this.$route.fullPath.substring(
      this.$route.fullPath.lastIndexOf("/") + 1
    );

    this.mySwiper = this.initSwiper(".building-banner-swiper-container");
    this.careerSwiper = this.initSwiper(".career-banner-swiper-container");
    this.careerSwiper = this.initSwiper(
      ".lifeCommunity-banner-swiper-container"
    );
  },
  methods: {
    locationMenuItemClick(menu) {
      // this.selectedMenu = menu;
      // this.goTop();
      window.location.href = menu;
    },
    initSwiper: function (clazz) {
      var swiperOptions = {
        loop: true,
        speed: 1000,
        autoplay: true,
        grabCursor: true,
        autoHeight: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        observer: true,

        pagination: {
          el: clazz + " .swiper-pagination",
        },
        navigation: {
          nextEl: clazz + " .button-next",
          prevEl: clazz + " .button-prev",
        },
        on: {},
      };

      return new Swiper(clazz, swiperOptions);
    },
  },
};
</script>

<style scoped lang="less">
@import "../../locations.less";
</style>
